"use client";

/**
 * 🔴 顺序预览弹层的开关状态（2026-10-14）。
 *
 * 为什么单独一个 store：入口按钮住在 `task-queue-dock`（右下角「后台任务」那一栏，
 * 用户指定的位置），弹层住在 `storyboard/page.tsx`（那里才有 shots / 成片地址）。
 * 让两者隔空联动又不硬传 prop，就用「只存开关」的极小 store ——
 * **数据仍留在页面**，store 里一个镜头字段都没有（否则就成了第二份事实）。
 */

import { create } from "zustand";

interface ShotPreviewState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

export const useShotPreviewStore = create<ShotPreviewState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));